import { z } from "zod";
import type { loginSchema } from "../auth/auth.schema.js";

export const whatsappSchema = z.object({
  numbers: z.array(z.string()).optional(),
  message: z.string().optional(),
});

export const paginationSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type WhatsAppSchemaType = z.infer<typeof whatsappSchema>;
export type PaginationSchemaType = z.infer<typeof paginationSchema>;
